import styled from 'styled-components';

import { Button } from '@xingternal/button';
import { IllustrationSpotBell } from '@xingternal/illustrations';
import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceM, spaceXL } from '@xingternal/tokens';
import { Headline } from '@xingternal/typography';
import { Column } from '@xingternal/xing-grid';

export const CreateAlertContainer = styled(Column)`
  display: flex;
  align-items: center;
  margin: ${spaceXL} 0;
`;

export const IconAlert = styled(IllustrationSpotBell)`
  display: flex;
  align-self: flex-start;
  margin: 0 ${spaceM} 0 0;
`;

export const CreateAlertBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  @media ${mediaConfined} {
    flex-direction: row;
    align-items: center;
  }
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceM};
  @media ${mediaConfined} {
    margin: 0 ${spaceXL} 0 0;
  }
`;

export const StyledButton = styled(Button)`
  align-self: flex-start;
  @media ${mediaConfined} {
    min-width: 224px;
  }
`;
